import React from 'react';
import nabeel from '../assets/svg/Home SVGs/Group 81.svg';
import Arrow from '@material-ui/icons/ArrowForward';
import { Link } from 'react-router-dom';
class Header extends React.Component {
  render() {
    return (
      <div className=' sm:pb-32 sm:pt-16 pt-4 pb-16 px-4 overflow-hidden'>
        <div
          className='flex flex-col justify-center content-center items-center
         sm:flex sm:flex-row sm:justify-around'
        >
          <div className=' text-center sm:-mt-20'>
            <p className=' arabic-text big  sm:text-right md:ml-64'>نبيل</p>
            <div className='md:ml-20'>
              <p className='arabic-text font-semibold text-4xl mt-8'>
                طريقك الامثل في إيصال مساعدتك
              </p>

              <Link
                to='/Dashboard'
                className=' hidden n-green  border rounded-full 
                 py-1 px-2 w-32 mt-4  self-start
                 sm:flex sm:justify-center sm:content-center '
              >
                <p className='font-semibold text-2xl'> إبدأ</p>
                <Arrow
                  alt='arrow'
                  className='my-auto ml-1'
                  style={{ fontSize: 30 }}
                />
              </Link>
            </div>
          </div>
          <div className=''>
            <img className='width-person pb-12' src={nabeel} alt='person'></img>
          </div>
          <Link
            to='/Dashboard'
            className='n-green  border rounded-full 
            py-1 px-2 w-32 mt-4 flex justify-center content-center
            block sm:hidden '
          >
            <p className='font-semibold text-2xl'> إبدأ</p>
            <Arrow
              alt='arrow'
              className='my-auto ml-1'
              style={{ fontSize: 30 }}
            />
          </Link>
        </div>
      </div>
    );
  }
}
export default Header;
